<script>
import config from "./../config.js";
import { formatDate } from "./helpers/datetime.js";
import { user } from './stores.js';
import { onMount } from 'svelte';
import Drawer from './components/Drawer.svelte';
import Picture from './components/gallery/Picture.svelte';
import Alerts from './components/Alerts.svelte';

let container;
let date = formatDate(new Date());
let current_user;
const unsubscribe = user.subscribe(value => {
    current_user = value;
});

let N = 0,
  NF = 30;

let i = 0,
  x0 = null,
  locked = false,
  w,
  ini,
  fin,
  rID = null;

function changeSlide(i) {
  container.style.setProperty("--i", i);
}

function stopAni() {
  cancelAnimationFrame(rID);
  rID = null;
}

function ani(cf = 0) {
  changeSlide(ini + (fin - ini) * cf / NF);

  if (cf === NF) {
    stopAni();
    return;
  }

  rID = requestAnimationFrame(ani.bind(this, ++cf));
}

function unify(e) {
  return e.changedTouches ? e.changedTouches[0] : e;
}

function lock(e) {
  x0 = unify(e).clientX;
  locked = true;
}

function drag(e) {
  e.preventDefault();
  if (locked) {
    let dx = unify(e).clientX - x0,
      f = +(dx / w).toFixed(2);
    changeSlide(i - f);
  }
}

function move(e) {
  if (locked) {
    let dx = unify(e).clientX - x0,
      s = Math.sign(dx),
      f = +(s * dx / w).toFixed(2);

    ini = i - s * f;

    if ((i > 0 || s < 0) && (i < N - 1 || s > 0) && f > 0.2) {
      i -= s;
      f = 1 - f;
    }

    fin = i;
    ani();
    x0 = null;
    locked = false;
  }
}

const KEY_LEFT = "ArrowLeft";
const KEY_RIGHT = "ArrowRight";
function keyslide(e) {
  if (e.key != KEY_LEFT && e.key != KEY_RIGHT) return;
  let i = parseInt(container.style.getPropertyValue("--i"), 10);
  if (e.key == KEY_LEFT) {
    if (i > 0) i = i - 1;
  }
  if (e.key == KEY_RIGHT) {
    if (i + 1 < N) i = i + 1;
  }

  changeSlide(i);
}

function size() {
  w = window.innerWidth;
}

function fetchGallery(url, token, date) {
  let headers = new Headers();
  headers.set("authorization", "Bearer " + token);

  return fetch(url + "?date=" + date, {
    headers: headers
  }).then(res => {
    if (res.status === 401) {
      window.location.assign("#login");
    }
    if (res.status === 404) {
      window.location.assign("#404");
    }
    if (!res.ok) {
      catchError(response);
    }
    return res.json();
  });
}

onMount(() => {
    size();

    container.style.setProperty("--n", N);

    addEventListener("resize", size, false);

    container.addEventListener("mousedown", lock, false);
    container.addEventListener("touchstart", lock, false);

    container.addEventListener("mousemove", drag, false);
    container.addEventListener("touchmove", drag, false);

    container.addEventListener("mouseup", move, false);
    container.addEventListener("touchend", move, false);

    document.addEventListener("keydown", keyslide, false);
});

function slideLeft(e) {
    let i = parseInt(container.style.getPropertyValue("--i"), 10);
    if (i > 0) i = i - 1;
    changeSlide(i);
};
function slideRight(e) {
    let i = parseInt(container.style.getPropertyValue("--i"), 10);
    if (i + 1 < N) i = i + 1;
    changeSlide(i);
};
function reload(e) {
    e.preventDefault();
    const { gallery } = config;
    
    return new Promise(fulfil => {
        fetchGallery(gallery["url"], current_user.token, date).then(res => {
            if (!res || !res["photos"]) return;
            N = res["photos"].length;
            container.style.setProperty("--n", N);

            return res;
            }).then(res => {
              fulfil(res);
            }).catch(error => console.error(error));
        }
    );
}

function getGallery() {
    return new Promise(fulfil => {
        const { gallery } = config;
        fetchGallery(gallery["url"], current_user.token, formatDate(new Date()))
            .then(res => {
              if (!res) return;
              if (!res["photos"] || !res["photos"].length) {
                  let yesterday = new Date();
                  yesterday.setDate(yesterday.getDate() - 1);
                  return fetchGallery(
                    gallery["url"],
                    current_user.token,
                    formatDate(yesterday)
                  );
              }
              N = res["photos"].length;
              container.style.setProperty("--n", N);
              // when retrieving curr day display latest pic front page
              res["photos"] = res["photos"].reverse();
              return res;
            }).then(res => {
              fulfil(res);
            }).catch(error => console.error(error));
        }
    )
};
    
</script>

<style>
form {
	position: absolute;
	top: 10px;
	width: 100%;
	display: flex;
	-webkit-box-align: center;
  align-items: center;
	justify-content: center;
	z-index: 1;
}
.container {
  margin-top: 0;
  margin-left: 0;
	--n: 1;
	display: flex;
	align-items: center;
	overflow-y: hidden;
	width: 100%;
	width: calc(var(--n)*100%);
	height: 100%;
	/*height: 50vw; */
	max-height: 100vh;
	transform: translate(calc(var(--i, 0)/var(--n)*-100%));
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
.control {
	position: fixed;
	z-index: 1;
	left: 5%;
	top: 50vh;
	cursor: pointer;
	font-size: 6em;
	color: #fff;
	padding: 20px;
	font-weight: 700;
	margin-top: -75px;
	margin-left: 60px;
	transition-property: margin;
  transition-duration: 0.5s;
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	 -khtml-user-select: none; /* Konqueror HTML */
		 -moz-user-select: none; /* Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
					user-select: none; /* Non-prefixed version, currently
																supported by Chrome and Opera */
}
.control.previous:hover {
	padding-right: 50px;
	padding-left: 20px;
	margin-left: 45px;
}
.control:hover {
	padding-right: 20px;
	padding-left: 50px;
	text-decoration: none;
	color: #ff717f;
	margin-right: -15px;
}
.next {
	right: 5%;
	left: auto;
}
.previous {

}
@media only screen and (max-width: 600px) {
	.container {
		margin-top: 80px;
	}
	form {
    bottom: auto;
    top: auto;
    position: relative;
    display: block;
	}
	.control {
		left: 0;
		margin-left: 0;
	}
	.control.previous:hover {
		padding-right: 20px;
		padding-left: 20px;
		margin-left: auto;
	}
	.control:hover {
		padding-right: 20px;
		padding-left: 20px;
		text-decoration: none;
		color: #ff717f;
		margin-right: auto;
	}
	.next {
		left: 100vw;
		margin-left: -60px;
	}
}
</style>

<Drawer />

<div class='container'
	bind:this={container}
	style="--i:0">
	{#await getGallery()}
		<p>Retrieving images...</p>
	{:then data}
		{#if data && data['photos']}
      {#each data['photos'] as image, i}
          <Picture src={image} container={container} i={i} />
      {/each}
		{/if}
	{:catch error}
			<p class="message">An error occurred while retrieving the gallery images :(</p>
	{/await}
</div>

<form on:submit|preventDefault={reload}>
    <input bind:value={date} placeholder="date" type="date" />
    <input type="submit" value="&#x21af;" />
</form>

<span class="previous control" role="button" tabindex="0" on:click={slideLeft} on:keydown={(e) => e.key === 'Enter' && slideLeft()}>.</span>
<span class="next control" role="button" tabindex="0" on:click={slideRight} on:keydown={(e) => e.key === 'Enter' && slideRight()}>.</span>